import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const RepairOrdersService = {
  async getAllRepairOrders() {
    let response = await $axios
      .get($api("repair_order"))
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getAllRepairOrderById(id: number) {
    let response = await $axios
      .get($api("repair_order_id", { id }))
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async deleteOrder(id: string) {
    let { data, status } = await $axios
      .delete($api("repair_order_id", { id }), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });
    return { data, status };
  },
};
